import React from "react";
// Common Components
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { ITableUI } from "src/Tables/TableTemplate/tableTemplate";
// Local Components
import { ConnectionTableAdditional } from "./ConnectionTableAdditional";
// Hooks
import { useAppSelector, useAppDispatch } from "src/App/hooks";
// Utilities
import { setSahraConnectionsTableFetchDataFlag } from "src/Features/SahraConnections/SahraConnectionsSlice";
// Types
import { IConnectionsReport } from "src/Interfaces/connections";

const TableUI: React.FC<ITableUI<IConnectionsReport>> = ({
  reports,
  onAction,
}: ITableUI<IConnectionsReport>) => {
  const flag = useAppSelector((store) => store.sahraConnections.tableFetchFlag);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (!!flag && onAction) {
      dispatch(setSahraConnectionsTableFetchDataFlag(false));
      onAction();
    }
  }, [flag]);

  return (
    <CommonTableUI
      onAction={onAction}
      AdditionalBody={ConnectionTableAdditional}
      tableBoxClassName="!w-full !max-w-none max-h-[500px]"
      reports={reports}
      hideWhenNoResp
      withSelect
    />
  );
};

export default TableUI;
